import "@/index.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/layout/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { IMAGES } from "@/data/site";

import Home from "@/pages/Home";
import Packages from "@/pages/Packages";
import PackageDetail from "@/pages/PackageDetail";
import Destinations from "@/pages/Destinations";
import DestinationDetail from "@/pages/DestinationDetail";
import TourCategory from "@/pages/TourCategory";
import Recommender from "@/pages/Recommender";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Corporate from "@/pages/Corporate";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FAQs from "@/pages/FAQs";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";
import Stories from "@/pages/Stories";
import Policies from "@/pages/Policies";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const Site = ({ children }) => <Layout>{children}</Layout>;

const DOMESTIC_PARAMS = { tour_type: "domestic" };
const INTERNATIONAL_PARAMS = { tour_type: "international" };
const PILGRIMAGE_PARAMS = { category: "pilgrimage" };
const GROUP_PARAMS = { tour_type: "group" };

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Site><Home /></Site>} />

          {/* Travel */}
          <Route path="/packages" element={<Site><Packages /></Site>} />
          <Route path="/packages/:slug" element={<Site><PackageDetail /></Site>} />
          <Route path="/domestic-tours" element={<Site><TourCategory title="Domestic Tours" seoTitle="Domestic Tour Packages in India" description="Explore VacanzaGo's pan-India domestic tour packages — Kashmir, Ladakh, Himachal, Goa, Sikkim and more." intro="Pan-India journeys, thoughtfully planned across every season and region." params={DOMESTIC_PARAMS} heroImage={IMAGES.heroSunrise} /></Site>} />
          <Route path="/international-tours" element={<Site><TourCategory title="International Tours" seoTitle="International Tour Packages" description="VacanzaGo's international travel — curated journeys beyond India. Tell us your dream and we'll craft it." intro="Journeys beyond India — curated for you. New destinations are being added; tell us where you dream of going." params={INTERNATIONAL_PARAMS} heroImage={IMAGES.heroGolden} /></Site>} />
          <Route path="/pilgrimage-tours" element={<Site><TourCategory title="Pilgrimage Tours" seoTitle="Pilgrimage Tours & Yatra Packages from Haridwar" description="Char Dham, Kedarnath, Badrinath, Amarnath, Vaishno Devi and sacred circuits — planned by Haridwar's trusted operator." intro="Sacred circuits across India, with nearly a decade of ground experience from our home city, Haridwar." params={PILGRIMAGE_PARAMS} heroImage={IMAGES.kedarnath} /></Site>} />
          <Route path="/group-tours" element={<Site><TourCategory title="Group Tours" seoTitle="Group Tour Packages" description="Travel together — VacanzaGo's group departures and group-friendly journeys across India." intro="Journeys designed to be shared — with friends, family or fellow travellers." params={GROUP_PARAMS} heroImage={IMAGES.heroExperience} /></Site>} />
          <Route path="/recommender" element={<Site><Recommender /></Site>} />
          <Route path="/destinations" element={<Site><Destinations /></Site>} />
          <Route path="/destinations/:slug" element={<Site><DestinationDetail /></Site>} />

          {/* Events */}
          <Route path="/events" element={<Site><Events /></Site>} />
          <Route path="/events/:type" element={<Site><EventDetail /></Site>} />

          {/* Corporate & B2B */}
          <Route path="/corporate-b2b" element={<Site><Corporate /></Site>} />
          <Route path="/corporate" element={<Navigate to="/corporate-b2b" replace />} />

          {/* Content */}
          <Route path="/journal" element={<Site><Journal /></Site>} />
          <Route path="/journal/:slug" element={<Site><JournalPost /></Site>} />
          <Route path="/blog" element={<Navigate to="/journal" replace />} />
          <Route path="/stories" element={<Site><Stories /></Site>} />
          <Route path="/about" element={<Site><About /></Site>} />
          <Route path="/contact" element={<Site><Contact /></Site>} />
          <Route path="/faqs" element={<Site><FAQs /></Site>} />
          <Route path="/policies" element={<Site><Policies /></Site>} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />

          <Route path="*" element={<Site><NotFound /></Site>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
